module.exports = __webpack_public_path__ + "img/ic_close_password_popup.b11c6a19.svg";